import type { ElementType, ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Section.module.css'

interface SectionProps {
  children: ReactNode
  as?: ElementType
  /** Uses the 30px block padding of the closing sections. */
  spacious?: boolean
  /** Widens the inner track to 1200px (footer only). */
  wide?: boolean
  id?: string
  className?: string
  /** Applied to the inner track rather than the outer band. */
  innerClassName?: string
}

/**
 * The page band: full-bleed background, 100px side gutter, content centred at
 * 1000px. Every section on the site is one of these, which is why no other
 * component sets a page gutter or a max width.
 */
export const Section = ({
  children,
  as: Component = 'section',
  spacious = false,
  wide = false,
  id,
  className,
  innerClassName,
}: SectionProps) => (
  <Component
    id={id}
    className={cn(styles.section, spacious && styles.spacious, className)}
  >
    <div className={cn(styles.inner, wide && styles.wide, innerClassName)}>
      {children}
    </div>
  </Component>
)
